import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { sdk } from '@/lib/sdk'
import { formatNumber } from '@/lib/formatters'

/* One read of the viewer's own statement per page load is enough to learn the community's name for
   points; the storefront cards and the redeem dialog share it. Reset when the session changes. */
let cached: Promise<string | null> | null = null

export const resetPointsName = (): void => { cached = null }

/**
 * F-160: "800 pontos", or the community's own name for them ("800 moedas"). `currencyName` comes from
 * `GET /api/points/me` (any member); until it answers, or when it fails, the default word is used.
 */
export function usePointsLabel(): (amount: number) => string {
  const { t, i18n } = useTranslation('points')
  const [name, setName] = useState<string | null>(null)

  useEffect(() => {
    let alive = true
    cached ??= sdk.points.me({ limit: 1 }).then((s) => s?.currencyName || null).catch(() => null)
    void cached.then((n) => { if (alive) setName(n) })
    return () => { alive = false }
  }, [])

  return useCallback((amount: number) => {
    const formatted = formatNumber(amount, i18n.language)
    return name ? `${formatted} ${name}` : t('amount', { count: amount, formatted })
  }, [name, t, i18n.language])
}
